import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

// import { HomeComponent } from './appviews/core/home/home.component';
// import { ChartWidgetComponent } from './widget/chart-widget/chart-widget.component';
// import { OverviewWidgetComponent } from './widget/overview-widget/overview-widget.component';

import {AllComponent} from './appviews/all/all.component';
import {ClothingComponent} from './appviews/clothing/clothing.component';
import {GlovesComponent} from './appviews/gloves/gloves.component';
import {KitsComponent} from './appviews/kits/kits.component';
import {MasksComponent} from './appviews/masks/masks.component';
import {ProductComponent} from './appviews/product/product.component';
import {SanitizersComponent} from './appviews/sanitizers/sanitizers.component';
import {VentilatorsComponent} from './appviews/ventilators/ventilators.component';
import {RecommendedComponent} from './appviews/recommended/recommended.component';
import {AboutComponent} from './appviews/about/about.component';
import {ContactComponent} from './appviews/contact/contact.component';
import {M31826Component} from './appviews/m31826/m31826.component';
import {KitAllplexComponent} from './appviews/kit-allplex/kit-allplex.component';
import {KitMedakitComponent} from './appviews/kit-medakit/kit-medakit.component';
import {VentYH830Component} from './appviews/vent-yh830/vent-yh830.component';
import {VentVG70Component} from './appviews/vent-vg70/vent-vg70.component';
import {Mask3m8210Component} from './appviews/mask3m8210/mask3m8210.component';
import {MaskKN95Component} from './appviews/mask-kn95/mask-kn95.component';
import {Mask3m1860Component} from './appviews/mask3m1860/mask3m1860.component';
import {Mask3PlyComponent} from './appviews/mask3-ply/mask3-ply.component';
import {MaskN95Component} from './appviews/mask-n95/mask-n95.component';
import {MaskN95NioshComponent} from './appviews/mask-n95-niosh/mask-n95-niosh.component';
import {MaskFaceShieldComponent} from './appviews/mask-face-shield/mask-face-shield.component';
import {MaskGogglesComponent} from './appviews/mask-goggles/mask-goggles.component';
import {SanitizerGallonComponent} from './appviews/sanitizer-gallon/sanitizer-gallon.component';
import {Sanitizer16Component} from './appviews/sanitizer16/sanitizer16.component';
import {GownSurgicalComponent} from './appviews/gown-surgical/gown-surgical.component';
import {GownIsolationComponent} from './appviews/gown-isolation/gown-isolation.component';

const routes: Routes = [
  {
    path: '',
    component: RecommendedComponent,
    pathMatch: 'full'
  },
  {
    path: 'clothing',
    component: ClothingComponent,
    pathMatch: 'full'
  },
  {
    path: 'gloves',
    component: GlovesComponent,
    pathMatch: 'full'
  },
  {
    path: 'kits',
    component: KitsComponent,
    pathMatch: 'full'
  },
  {
    path: 'masks',
    component: MasksComponent,
    pathMatch: 'full'
  },
  {
    path: 'product',
    component: ProductComponent,
    pathMatch: 'full'
  },
  {
    path: 'kits',
    component: KitsComponent,
    pathMatch: 'full'
  },
  {
    path: 'sanitizers',
    component: SanitizersComponent,
    pathMatch: 'full'
  },
  {
    path: 'ventilators',
    component: VentilatorsComponent,
    pathMatch: 'full'
  },
  {
    path: 'about',
    component: AboutComponent,
    pathMatch: 'full'
  },
  {
    path: 'contact',
    component: ContactComponent,
    pathMatch: 'full'
  },
  {
    path: '3m1826',
    component: M31826Component,
    pathMatch: 'full'
  },
  {
    path: 'allplex',
    component: KitAllplexComponent,
    pathMatch: 'full'
  },
  {
    path: 'medakit',
    component: KitMedakitComponent,
    pathMatch: 'full'
  },
  {
    path: 'vg70',
    component: VentVG70Component,
    pathMatch: 'full'
  },
  {
    path: 'yh830',
    component: VentYH830Component,
    pathMatch: 'full'
  },
  {
    path: '3m8210',
    component: Mask3m8210Component,
    pathMatch: 'full'
  },
  {
    path: 'kn95',
    component: MaskKN95Component,
    pathMatch: 'full'
  },
  {
    path: '3m1860',
    component: Mask3m1860Component,
    pathMatch: 'full'
  },
  {
    path: '3ply',
    component: Mask3PlyComponent,
    pathMatch: 'full'
  },
  {
    path: 'n95',
    component: MaskN95Component,
    pathMatch: 'full'
  },
  {
    path: 'n95niosh',
    component: MaskN95NioshComponent,
    pathMatch: 'full'
  },
  {
    path: 'shield',
    component: MaskFaceShieldComponent,
    pathMatch: 'full'
  },
  {
    path: 'goggles',
    component: MaskGogglesComponent,
    pathMatch: 'full'
  },
  {
    path: 'sanitizer16',
    component: Sanitizer16Component,
    pathMatch: 'full'
  },
  {
    path: 'sanitizergallon',
    component: SanitizerGallonComponent,
    pathMatch: 'full'
  },
  {
    path: 'surgicalgown',
    component: GownSurgicalComponent,
    pathMatch: 'full'
  },
  {
    path: 'isolationgown',
    component: GownIsolationComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        // useHash: true,
        scrollPositionRestoration: 'enabled',
        preloadingStrategy: PreloadAllModules
      })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}

